import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  jsonProperty: any;
  appConfig: any;
  jsonConfig: any;

  constructor(private httpClient: HttpClient, private userService: UsersService) {}

  loadConfig() {
    return this.httpClient.get<any>("assets/productKeys.json")
      .toPromise()
      .then(res => {
        this.appConfig = res;
      });
  }

  async jsonConfigData(): Promise<any> {
    let jsonAwait: any = [];
    const storedData = localStorage.getItem("md_jsonData");
    if (storedData) {
      jsonAwait = JSON.parse(storedData);
    } else {
      jsonAwait = await this.httpClient.get<any>("assets/domainProperty.json").toPromise();
    }

    jsonAwait.forEach(domainName => {

      environment.Base_url = domainName.dashboard.Base_url;
      console.log("environment.base_url::",environment.Base_url)
      environment.signUpUrl = `${environment.Base_url}${domainName.dashboard.signUpUrl}`;
      environment.signInUrl = `${environment.Base_url}${domainName.dashboard.signInUrl}`;
      environment.mailto = `${domainName.dashboard.mailto}`;
      environment.bankLogin = `${environment.Base_url}${domainName.dashboard.bankLogin}`;
     environment.applyNowUrl = `${domainName.dashboard.applyNowUrl}`;
    });

    localStorage.setItem('md_jsonData', JSON.stringify(jsonAwait));
    this.jsonConfig = jsonAwait;
    localStorage.setItem("md_jsonData", JSON.stringify(this.jsonConfig));
    this.userService.domainProperty = JSON.parse(localStorage.getItem('md_jsonData'))[0];

    if (storedData) {
      return Promise.resolve(JSON.parse(storedData));
    }
    return jsonAwait;
  }
}
